export class TabellaStatisticheModel {
  headers: TabellaStatisticheHeader[] = [];

  dati: any[] = [];
}

export class TabellaStatisticheHeader {
  nomeCampo: string = '';
  caption: string = '';
  tipo: string = '';
  formato: string = '';
}
